import { LOCATION_AREAS_SUCCESS } from '../actions/areas'

import {
  SET_CONTRACT_FILTER,
  SET_AREA_TYPE_FILTER,
  SET_SUB_LOCATION_FILTER,
  SET_SERVICE_FILTER,
  SET_AMOUNT_FILTER,
  SET_SORTING,
  SET_DATE_PERIOD_FILTER,
  SET_LAST_CLEANED_FILTER
} from '../actions/work-tracker-filters'

const defaultState = {
  sorting: {
    'desc': { id: 'desc', name: 'Most Recent' },
    'asc': { id: 'asc', name: 'Last' }
  },
  amount: {
    '0': { id: '0', name: '0' },
    '1': { id: '1', name: '1' },
    '2': { id: '2', name: '2' },
    '3': { id: '3', name: '3' },
    '4': { id: '4', name: '4' },
    '5': { id: '5', name: '5+' }
  }
}

export default function (state = defaultState, action) {
  switch (action.type) {
    case SET_CONTRACT_FILTER:
      return {
        ...state,
        [action.payload.locationId]: {
          ...state[action.payload.locationId],
          contractId: action.payload.contractId,
          hasNewFilters: true
        }
      }

    case SET_AREA_TYPE_FILTER:
      return {
        ...state,
        [action.payload.locationId]: {
          ...state[action.payload.locationId],
          areaTypeId: action.payload.areaTypeId,
          hasNewFilters: true
        }
      }

    case SET_SUB_LOCATION_FILTER:
      return {
        ...state,
        [action.payload.locationId]: {
          ...state[action.payload.locationId],
          subLocationId: action.payload.subLocationId,
          hasNewFilters: true
        }
      }

    case SET_SERVICE_FILTER:
      return {
        ...state,
        [action.payload.locationId]: {
          ...state[action.payload.locationId],
          serviceId: action.payload.serviceId,
          ...action.payload.hasOwnProperty('amountIds') && { amountIds: action.payload.amountIds },
          hasNewFilters: true
        }
      }

      case SET_AMOUNT_FILTER:
        return {
          ...state,
          [action.payload.locationId]: {
            ...state[action.payload.locationId],
            amountIds: action.payload.amountIds,
            hasNewFilters: true
          }
        }

      case SET_LAST_CLEANED_FILTER:
        return {
          ...state,
          [action.payload.locationId]: {
            ...state[action.payload.locationId],
            lastCleaned: action.payload.lastCleaned,
            hasNewFilters: true
          }
        }

    case SET_SORTING:
      return {
        ...state,
        [action.payload.locationId]: {
          ...state[action.payload.locationId],
          sortingId: action.payload.sortingId,
          hasNewFilters: true
        }
      }

    case SET_DATE_PERIOD_FILTER:
      const { datePeriod } = action.payload

      return {
        ...state,
        [action.payload.locationId]: {
          ...state[action.payload.locationId],
          datePeriod,
          hasNewFilters: true
        }
      }

    case LOCATION_AREAS_SUCCESS:
      return {
        ...state,
        [action.payload.locationId]: {
          ...state[action.payload.locationId],
          hasNewFilters: false
        }
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/work-tracker-filters.js